const money = (value: number) => {
  const valueFixed = value.toFixed(2)
  const valueBRL = valueFixed.replace('.', ',')
  return `R$${valueBRL}`
}

export { money }
